import { useMediaQuery } from '@vueuse/core'
import _ from 'lodash'

export default defineNuxtPlugin(async (nuxtApp) => {
  // const appStateStore = useAppStateStore();
  // // const $route = useRoute()

  // const isMobile = useMediaQuery('(max-width: 768px)')
  // return

  // watchEffect(() => {
  //   // user in brand
  //   const isBrandLayout = _.includes($route.path, 'brand')
  //   if(isBrandLayout) {
  //     return 
  //   }

  //   const isForceToProducebookPage = _.includes($route.path, '/producebook')
  //   const isForceToUploadPage = _.includes($route.path, '/upload')
  //   const isForceToWishesPage = _.includes($route.path, '/sort')
  //   if(isForceToProducebookPage || isForceToUploadPage || isForceToWishesPage) {
  //     return 
  //   }

  //   // set isDesktop
  //   appStateStore.isDesktop = isMobile.value ? false : true

  //   // User is on mobile: redirect to v3
  //   const isMobilePage = _.includes($route.path, '/v3')
  //   if (isMobile.value && !isMobilePage) {
  //     useRouter().push('/v3/home')
  //   } 
    
  //   // user is on desktop : redirect to desktop
  //   const isDesktopPage = _.includes($route.path, '/desktop')
  //   if(!isMobile.value && !isDesktopPage) {
  //     useRouter().push('/desktop') 
  //   } 
  // })
})